import {
  useCreateTask,
  useDeleteTask,
  useUpdateTask,
  useArchiveTask,
} from "../hooks";
import { validateTask } from "../utils";

export const useTaskTableHandlers = ({
  scheduleTasks,
  tasksLoading,
  loadScheduleTasks,
  setSnackbar,
}) => {
  const { mutateAsync: archiveTaskMutation } = useArchiveTask();

  const useCreateTaskWithNotification = () => {
    const mutation = useCreateTask();

    return {
      ...mutation,
      mutateAsync: async (variables) => {
        try {
          const result = await mutation.mutateAsync(variables);
          await loadScheduleTasks();

          setSnackbar({
            open: true,
            message: "Task created successfully!",
            severity: "success",
          });

          return result;
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Failed to create task";

          setSnackbar({
            open: true,
            message: errorMessage,
            severity: "error",
          });

          throw error;
        }
      },
    };
  };

  const useUpdateTaskWithNotification = () => {
    const mutation = useUpdateTask();

    return {
      ...mutation,
      mutateAsync: async (variables) => {
        try {
          const result = await mutation.mutateAsync(variables);
          await loadScheduleTasks();

          setSnackbar({
            open: true,
            message: "Task updated successfully!",
            severity: "success",
          });

          return result;
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Failed to update task";

          setSnackbar({
            open: true,
            message: errorMessage,
            severity: "error",
          });

          throw error;
        }
      },
    };
  };

  const useDeleteTaskWithNotification = () => {
    const mutation = useDeleteTask();

    return {
      ...mutation,
      mutateAsync: async (variables) => {
        try {
          const result = await mutation.mutateAsync(variables);
          await loadScheduleTasks();

          setSnackbar({
            open: true,
            message: "Task deleted successfully!",
            severity: "success",
          });

          return result;
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Failed to delete task";

          setSnackbar({
            open: true,
            message: errorMessage,
            severity: "error",
          });

          throw error;
        }
      },
    };
  };

  const hooks = {
    useCreateItem: () => useCreateTaskWithNotification(),
    useGetItems: () => ({
      data: scheduleTasks,
      isLoading: tasksLoading,
    }),
    useUpdateItem: () => useUpdateTaskWithNotification(),
    useDeleteItem: () => useDeleteTaskWithNotification(),
  };

  const actions = {
    validateItem: validateTask,
    archiveItem: async ({ id, accessToken }) => {
      try {
        await archiveTaskMutation({ id, accessToken });
        await loadScheduleTasks();

        setSnackbar({
          open: true,
          message: "Task archived successfully!",
          severity: "success",
        });
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to archive task";

        setSnackbar({
          open: true,
          message: errorMessage,
          severity: "error",
        });

        throw error;
      }
    },
  };

  return {
    hooks,
    actions,
  };
};
